"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtensions = exports.getOasTags = exports.getValidOasParameters = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../utils");
const ROOT_EXTENSIONS = ['x-internal'];
function getValidOasParameters(document, operationParameters, pathParameters) {
    const resolvedOperationParams = lodash_1.map(operationParameters, x => utils_1.maybeResolveLocalRef(document, x));
    const resolvedPathParams = lodash_1.map(pathParameters, x => utils_1.maybeResolveLocalRef(document, x));
    return lodash_1.unionBy(resolvedOperationParams, resolvedPathParams, (parameter) => {
        return lodash_1.isObject(parameter) ? `${parameter.name}-${parameter.in}` : 'invalid';
    })
        .filter(lodash_1.isObject)
        .filter(isValidOasParameter);
}
exports.getValidOasParameters = getValidOasParameters;
const isValidOasParameter = (parameter) => 'name' in parameter && typeof parameter.name === 'string' && 'in' in parameter && typeof parameter.in === 'string';
function getOasTags(tags) {
    return Array.isArray(tags) ? tags.filter(tag => typeof tag !== 'object').map(String) : [];
}
exports.getOasTags = getOasTags;
function getExtensions(target) {
    return lodash_1.fromPairs(Object.entries(target).filter(([key]) => key.startsWith('x-') && !ROOT_EXTENSIONS.includes(key)));
}
exports.getExtensions = getExtensions;
//# sourceMappingURL=accessors.js.map